import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import Footer from '../../components/Footer';
import 'wicg-inert';
import ScrollToTop from "../../libs/scrollToTop";
import { useKonami } from 'react-konami-code';
import Nav from '../../components/Nav.js';
import SecondaryNav from '../../components/SecondaryNav';

import heroMobileImage from '../../images/articles/wf-isf-expanded-goals-hero-mobile-v2.jpg';
import heroDesktopImage from '../../images/articles/wf-isf-expanded-goals-hero-desktop-v2.jpg';

import bodyDesktopImage from '../../images/articles/wf-isf-expanded-goals-body1-desktop.jpg';
import bodyMobileImage from '../../images/articles/wf-isf-expanded-goals-body1-mobile.jpg';

import ModalOverlay from "../../components/ModalOverlay";
import GoalsWaterGraph from '../../images/articles/Goals-Water.svg';
import GoalsWasteGraph from '../../images/articles/Goals-Waste.svg';
import GoalsGHGGraph from '../../images/articles/Goals-GHG.svg';
import GoalsEnergyGraph from '../../images/articles/Goals-Energy.svg';

import { fireTag } from '../../libs/analytics.js';

const Goals = ({
				   handleEvent,
				   modalOverlay,
				   closeExitOverlay,
				   addExitClickListeners,
			   }) => {

	const [enableScrollGA, setEnableScrollGA] = useState(false);
	const [shouldBeInert, setShouldBeInert] = useState(false);
	const [gridVisible, setGridVisible] = useState(false);
	const heroOGImage = 'wf-isf-articles-expanded-op-goals-share.jpg';

	addExitClickListeners();

	const toggleInert = () => {
		setShouldBeInert(!shouldBeInert)
	}


	const toggleGrid = () => {
		const grid = document.getElementsByClassName('grid')[0];
		grid.style.display = (!gridVisible) ? 'none' : 'block';
		setGridVisible(!gridVisible)
	}

	const KonamiElement = () => {
		useKonami(toggleGrid, {
			code: [37, 39, 37, 39]
		});
		return <div className="grid" style={{display: gridVisible ? 'block' : 'none'}}/>;
	};

	const linkDisclosures = () => {
		const bodyDisclosures = document.querySelectorAll('.body-disclosures');
		const footerDisclosures = document.querySelectorAll('.footer-disclosures');
		bodyDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = footerDisclosures[disclosureNumber - 1];
				fireTag("A2",disclosureNumber);
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});

				window.setTimeout(() => {
					// console.log(' ======== ');
					// console.log(targetElement);
					targetElement.focus();
				}, 1000);

			});
		});

		footerDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = bodyDisclosures[disclosureNumber - 1];
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});
				window.setTimeout(() => {
					targetElement.focus();
				}, 1000);
			});
		});
	}


	useEffect(() => {

		// console.log(`To see grid overlay, type ↑ ↑ ↓ ↓ ← → ← → B A inside the browser window`);
		ScrollToTop(setEnableScrollGA)
		linkDisclosures();

	}, []); // empty array says only use this effect once

	let mastheadImage;
	let bodyImage;

	switch (true) {
		case (window.innerWidth < 768):
			mastheadImage = heroMobileImage;
			bodyImage = bodyMobileImage;
			break;
		case (window.innerWidth < 1440):
			mastheadImage = heroDesktopImage;
			bodyImage = bodyDesktopImage;
			break;
		case (window.innerWidth >= 1440):
			mastheadImage = heroDesktopImage;
			bodyImage = bodyDesktopImage;
			break;
	}
	// console.log(mastheadImage);

	return (
		<>
			<Helmet>
				<title>Wells Fargo sets expanded operational goals</title>
				<meta
					name="description"
					content="The company is building on its progress and adding more sustainable features to new and existing buildings."
				/>
				<meta property="og:title" content="Wells Fargo sets expanded operational goals"/>
				<meta
					property="og:description"
					content="The company is building on its progress and adding more sustainable features to new and existing buildings."
				/>
				<meta property="og:image" content={`https://welcome.wf.com/impact/images/articles/wf-isf-articles-expanded-op-goals-share.jpg`}/>

				<meta property="twitter:title" content="Wells Fargo sets expanded operational goals"/>
				<meta
					property="twitter:description"
					content="The company is building on its progress and adding more sustainable features to new and existing buildings."
				/>
			</Helmet>
			{/*TODO: isMobile should be passed in from route, not calc'd here */}
			<Nav handleEvent={handleEvent} isNotHomePage={false} activePage="articles" isMobile={window.innerWidth < 768} showExternalNav toggleInert={toggleInert} shouldBeInert={shouldBeInert}/>
			{!window.innerWidth < 768 && (
				<SecondaryNav page="Articles" shouldBeInert={shouldBeInert} activePage="articles"/>
			)}

			<main className='flex-container article-3'>

				<div className="flex-row">
					{/*flex-col-md-8*/}
					<div className="flex-col-sm-12 text-center headline">
						<h1 id="articles-main-h1" style={{marginBottom: 10}}>
							Wells Fargo sets expanded operational goals
						</h1>
						<h2 className="summary">
							The company is building on its progress and adding more sustainable features to new and existing buildings.
						</h2>
					</div>
				</div>

				<div className="flex-row full-width exception goals">
					<div className="flex-col-lg-10 flex-col-md-10 text-center hero-container">
						<img src={mastheadImage} alt={"A Wells Fargo branch in a suburban commercial area."}/>
					</div>
				</div>

				<div className="flex-row">
					<div className="flex-col-md-12 flex-col-sm-12 text-center article-intro info-graphic">
						<div className="by-line">
							<p>By Curt Radkin, <span>sustainability strategy and planning director at Wells Fargo, Corporate Properties Group</span></p>
						</div>
						<div className="article-info">
							<div>
								<p>August 1, 2023</p>
							</div>
							<div>
								<p>5-minute read</p>
							</div>
						</div>
						<p>Wells Fargo is a contributor in the transition to a low-carbon economy, taking steps to create a more sustainable future. As part of our efforts to transition to cleaner energy sources and reduce emissions, we are setting new goals to further embed sustainability in our operations.</p>

						<p>In April, Wells Fargo broke ground on a cutting-edge, state-of-the-art campus in the Dallas area. Upon completion, the campus — which is expected to open in 2025 — is anticipated to showcase the construction of the bank’s first Net Positive Energy buildings, which use rooftop solar panels to create more energy than the building consumes annually. Plans for the campus include electric vehicle (EV) charging stations, dynamic glass that automatically tints in direct sunlight, water reclamation, and native plantings to minimize watering requirements.</p>
						<div className="flex-row article-image">
							<img alt={'A group of dignitaries pose at a groundbreaking ceremony for a state-of-the-art campus in Irving, TX.'} src={bodyImage}/>
							<p className="image-caption">Front Row (l-r): Steve Van Amburgh, CEO of KDC; Charlie Scharf, CEO of Wells Fargo; Texas Governor Greg Abbott; Irving, TX Mayor Rick Stopfer; and Beth Bowman, President and CEO, Irving-Las Colinas Chamber of Commerce</p>
						</div>

						<p>This new facility is an outcome of our decade-long journey to improve and embed sustainability in our operations. To date, Wells Fargo has commissioned solar panels at nearly 60 facilities across the country. A <a onClick={()=> fireTag('A1','solar array')} target="_blank" href="https://www.businessrecord.com/wells-fargo-celebrates-completion-of-solar-array-in-west-des-moines-2/" rel="noreferrer" data-click-listener="true">solar array</a> at our Jordan Creek campus in Iowa offsets more than 10% of our on-campus energy needs. We also have agreements with utilities and renewable energy suppliers nationwide for offsite utility-scale renewable energy, including a 58-megawatt 600-acre <a onClick={()=> fireTag('A1','solar facility')} target="_blank" href="https://www.businesswire.com/news/home/20210408005207/en/Wells-Fargo-Announces-Major-Solar-Expansion-in-North-Carolina " rel="noreferrer">solar facility</a> with Duke Energy and NextEra Energy Resources in the Carolinas, 35 miles west of Charlotte. Collectively, Wells Fargo is developing on-site solar generation assets at nearly 30 corporate and retail locations in California, Arizona, and Minnesota, while supporting new sources of renewable energy across 13 states and two non-U.S. countries.
						</p>
						<p>In addition to advances in renewable energy, we are switching from traditional fluorescent lighting to LED lights throughout our existing branches. We are also exploring new opportunities to provide additional EV charging to employees in our largest office buildings.</p>

						<h2 className="subhead">Meeting goals and setting new ones that raise the bar</h2>

						<p>As businesses begin to see the real impacts of their sustainability improvements, goals and commitments can become more ambitious. Wells Fargo issued its first operational sustainability goals in 2012, with a focus on meeting them by 2020. We exceeded our 2020 goals to reduce energy use, water, waste, and greenhouse gas emissions. We have also met 100% of our annual global electricity needs with renewable energy since 2017, primarily through the purchase of Renewable Energy Certificates (RECs).
						</p>

						<p className="bottom-text">Wells Fargo is building on its accomplishments by setting expanded operational sustainability goals for 2030. These objectives include reducing greenhouse gas (GHG) emissions (Scope 1 and 2) from 2019 levels by 70%, energy and waste usage by 50%, and water usage by 45%. We also plan to invest in new renewable projects to match 100% of annual purchased electricity needs. </p>

						<div className="flex-row full-width exception">
							<div className="flex-row text-center">
								{/*outline: "1px solid black"*/}
								<div className="flex-col-md-12 flex-col-sm-12 text-center content-box" style={{maxWidth: '928px', marginLeft: 'auto', marginRight: 'auto',}}>
									<div className="content-header bulleted">
										<h2 className="content-title bulleted">Reduction goals in greenhouse gas emissions (GHG), energy, waste, and water</h2>
									</div>
									<div className="inner-content bulleted">
										<div className="content">
											<div id="event-tiles" className={""}>

												<div className={'tile-container'}>
													<img className="tile tile1" tabIndex={-1} src={GoalsGHGGraph} alt="A donut graph showing a 70% reduction in GHG emissions."/>

													<img className="tile tile2" tabIndex={-1} src={GoalsEnergyGraph} alt="A donut graph showing a 50% reduction in energy usage."/>

													<img className="tile tile3" tabIndex={-1} src={GoalsWasteGraph} alt="A donut graph showing a 50% reduction in waste usage."/>

													<img className="tile tile4" tabIndex={-1} src={GoalsWaterGraph} alt="A donut graph showing a 45% reduction in water usage."/>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>


				<div className="flex-row">
					<div className="flex-col-md-12 flex-col-sm-12 text-center article-intro" style={{paddingTop: 0}}>

						<h2 className="subhead">Building on our progress to develop strong relationships</h2>

						<p>Sustainability is a growing business opportunity. Banking customers are <a onClick={()=> fireTag('A1','increasingly interested')} target="_blank" href="https://www.mckinsey.com/capabilities/sustainability/our-insights/green-growth-unlocking-sustainability-opportunities-for-retail-banks" rel="noreferrer" data-click-listener="true">increasingly interested</a> in sustainability-related financial products and services. Wells Fargo has a goal of deploying $500 billion in sustainable finance by 2030, and in the first two years of tracking, we've originated, committed, advised, or facilitated approximately $129 billion.
						</p>

						<p>We are working alongside our business clients who engage with us for sustainable financing. Our corporate properties and planning teams are asked to join client conversations to share our experiences and insights on navigating a sustainable path. We recognize that our customers want to know how we've done what we've done, and we are eager to share some of our lessons learned.</p>

						<p>Wells Fargo’s sustainability goals are a company-wide priority. Our approach to improving our operations demonstrates our commitment to our employees, customers, and the communities where we live and work.
						</p>
					</div>
				</div>


				{/*<KonamiElement className="grid"/>*/}
			</main>

			<Footer id="footer" footerStyles="global" shouldBeInert={shouldBeInert} activePage="sustainability" enableScrollGA={enableScrollGA}/>
			{/* Adobe retargeting tag */
			}
			{
				/*
					REMOVE TAG
								<img alt="" src="https://rtd-tm.everesttech.net/upi/?sid=s6cvr4h2qH04B3WUwCOG&cs=1" style={{display: 'none'}}/>
				*/
			}

			{
				modalOverlay && modalOverlay.open && (
					<ModalOverlay closeExitOverlay={closeExitOverlay} modalOverlay={modalOverlay}/>
				)
			}
		</>
	)
};

export default withRouter(Goals);
